// extracted by mini-css-extract-plugin
export var black = "_24-6";
export var brand = "_24-1";
export var ddefault = "_24-0";
export var error = "_24-3";
export var gray = "_24-2";
export var highContrast = "_24-8";
export var outline = "_24-7";
export var success = "_24-5";
export var warning = "_24-4";